export const NETWORK_ERROR_DEDUPE_KEY = 'network-error/global' as const

export const NETWORK_TOAST_THROTTLE_MS = 150_000

export const NETWORK_TOAST_DURATION_MS = 10_000
export const NETWORK_TOAST_DURATION_S = NETWORK_TOAST_DURATION_MS / 1000
